import { useAppTranslation } from '@/hooks/useAppTranslation';
import { Ionicons } from '@expo/vector-icons';
import { SizableText, useTheme, XStack } from 'tamagui';

interface TrySearchRowProps {
  onTrySearch: () => void;
}

export const TrySearchRow = ({
  onTrySearch,
}: TrySearchRowProps): React.ReactElement => {
  const { t } = useAppTranslation();
  const theme = useTheme();

  return (
    <XStack alignItems="center" gap="$1">
      <Ionicons
        name="information-circle-outline"
        size={16}
        color={theme.secondary75?.val}
      />
      <SizableText size="$2" color="$secondary75">
        {t('speciesSearch.ai.wrongGuess')}
      </SizableText>
      <SizableText
        size="$2"
        color="$brand"
        fontFamily="$bold"
        onPress={onTrySearch}
        cursor="pointer"
        hoverStyle={{ opacity: 0.8 }}
      >
        {t('speciesSearch.ai.trySearch')}
      </SizableText>
    </XStack>
  );
};
